
document.addEventListener("click", (e) => {
	if (e.target.matches('.product-details .cart-add_btn')) {
			e.preventDefault();
			const button = e.target;
			const itemId = Number(button.getAttribute('id'));

			if (isNaN(itemId)) {
					console.error('Invalid item ID:', itemId);
					return;
			}

			// Prepare form data
			const formData = {
					items: [{
							id: itemId,
							quantity: 1
					}]
			};

			const loadingSpinner = button.querySelector(".loading__spinner");
			if (loadingSpinner) {
					loadingSpinner.classList.remove("hidden");
			}


			button.childNodes.forEach(child => {
					if (child.nodeType === Node.TEXT_NODE) {
							button.removeChild(child);
					}
			});

			(async () => {
					try {
							// Add item to cart
							await fetch("/cart/add.js", {
									method: "POST",
									headers: {
											"Content-Type": "application/json",
									},
									body: JSON.stringify(formData),
							});

							// Update cart drawer
							const cartDrawerResponse = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
							const cartDrawerHtml = await cartDrawerResponse.text();
							const htmlDocument = new DOMParser().parseFromString(cartDrawerHtml, "text/html");

							["cart-drawer-items", ".cart-drawer__footer"].forEach(selector => {
									const targetElement = document.querySelector(selector);
									const sourceElement = htmlDocument.querySelector(selector);
									if (targetElement && sourceElement) {
											targetElement.replaceWith(sourceElement);
									} else {
											console.error('Element not found for selector:', selector);
									}
							});

							// Update cart count bubble
							const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
							const cartData = await cartResponse.json();
							const cartBubble = document.querySelector(".cart-count-bubble span");
						 let insertHead = document.querySelector('.drawer__heading span');
			 				insertHead.innerHTML = `(${cartData.item_count})`
							if (cartBubble) {
									cartBubble.innerHTML = cartData.item_count;
							} else {
									const cartLink = document.querySelector("#cart-icon-bubble");
									cartLink.insertAdjacentHTML("beforeend", `
											<span class="visually-hidden">Cart</span>
											<div class="cart-count-bubble">
													<span aria-hidden="true">${cartData.item_count}</span>
													<span class="visually-hidden">${cartData.item_count} items</span>
											</div>
									`);
							}

							if(cartData.item_count == 0){
								document.querySelector('cart-drawer.drawer').classList.add('is-empty');
							}

							// To trigger the Event
							document.dispatchEvent(custom_addToCart);

					} catch (error) {
							console.error("Error:", error);
					} finally {
						// Hide loading spinner and restore button text
						if (loadingSpinner) {
							loadingSpinner.classList.add("hidden");
						}
						if (button) {
							button.insertAdjacentText("beforeend", "ADD TO CART");
						}
						var cartHeading = $('.cart-drawer .drawer__cart-items-wrapper .product-details h3.card__heading')
            if(cartHeading){
              equalHeight(cartHeading);
            }
					}
			})();
	}
});